import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-casinoslot',
  templateUrl: './casinoslot.component.html',
  styleUrls: ['./casinoslot.component.scss'],
})
export class CasinoslotComponent implements OnInit {
  title = 'app-casinoslot';

  ngOnInit(): void {}
}
